var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('title-bar',{on:{"toggle":_vm.toggleDrawer}}),_c('app-drawer',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('div',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'page-container' : ''},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }